import { useContext } from 'react';
import { CurrentUserContext } from 'contexts';

const useCurrentUserContext = () => useContext(CurrentUserContext);

export { useCurrentUserContext };
